import { ChainId } from 'vvs-sdk'
import addresses from 'config/constants/contracts'
import { Address } from 'config/constants/types'

export const getAddress = (address: Address): string => {
  const chainId = process.env.REACT_APP_CHAIN_ID
  return address[chainId] ? address[chainId] : address[ChainId.MAINNET]
}

export const getCraftsmanAddress = () => {
  return getAddress(addresses.craftsman)
}
export const getCraftsmanV2Address = () => {
  return getAddress(addresses.craftsmanV2)
}
export const getMulticallAddress = () => {
  return getAddress(addresses.multiCall)
}
export const getLotteryV2Address = () => {
  return getAddress(addresses.lotteryV2)
}
export const getPancakeProfileAddress = () => {
  return getAddress(addresses.pancakeProfile)
}
export const getPancakeRabbitsAddress = () => {
  return getAddress(addresses.pancakeRabbits)
}
export const getBunnyFactoryAddress = () => {
  return getAddress(addresses.bunnyFactory)
}
export const getClaimRefundAddress = () => {
  return getAddress(addresses.claimRefund)
}
export const getPointCenterIfoAddress = () => {
  return getAddress(addresses.pointCenterIfo)
}
export const getBunnySpecialAddress = () => {
  return getAddress(addresses.bunnySpecial)
}
export const getTradingCompetitionAddress = () => {
  return getAddress(addresses.tradingCompetition)
}
export const getEasterNftAddress = () => {
  return getAddress(addresses.easterNft)
}
export const getVvsVaultAddress = () => {
  return getAddress(addresses.vvsVault)
}
export const getPredictionsAddress = () => {
  return getAddress(addresses.predictions)
}
export const getChainlinkOracleAddress = () => {
  return getAddress(addresses.chainlinkOracle)
}
export const getBunnySpecialCakeVaultAddress = () => {
  return getAddress(addresses.bunnySpecialCakeVault)
}
export const getBunnySpecialPredictionAddress = () => {
  return getAddress(addresses.bunnySpecialPrediction)
}
export const getBunnySpecialLotteryAddress = () => {
  return getAddress(addresses.bunnySpecialLottery)
}
export const getFarmAuctionAddress = () => {
  return getAddress(addresses.farmAuction)
}
export const getConditionalLiquidityAddress = () => {
  return getAddress(addresses.conditionalLiquidity)
}
export const getTradingBattleAddress = () => {
  return getAddress(addresses.tradingBattle)
}
export const getVvsBarAddress = () => {
  return getAddress(addresses.vvsBar)
}
export const getVvsBoostAddress = () => {
  return getAddress(addresses.vvsBoost)
}
export const getZapAddress = () => {
  return getAddress(addresses.zap)
}
export const getZapEstimatorAddress = () => {
  return getAddress(addresses.zapEstimator)
}
export const getVvsMinerMoleAddress = () => {
  return getAddress(addresses.vvsMole)
}
export const getVvsMinerMoleNurseryAddress = () => {
  return getAddress(addresses.vvsMoleNursery)
}
export const getVvsFarmBoostAddress = () => {
  return getAddress(addresses.vvsFarmBoost)
}
export const getCroIdRegistryAddress = () => {
  return getAddress(addresses.croIdRegistry)
}
export const getArgoNftAddress = () => {
  return getAddress(addresses.argoNftCollection)
}
